import { FormControl, Grid, InputAdornment, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { ValidationError, object, string } from "yup";
import styles from "../reportSection.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";

interface ErrorMessageTypesBySignIn {
  signInName: string;
  searchByWeekly: string;
  searchByMonthly: string;
  searchByQuarterly: string;
  selectYear: string;
  searchYear: string;
  formError?:string;
}
const formFieldsSignIn = {
  signInName: "",
  searchByWeekly: dayjs().format("YYYY-MM-DD"),
  searchByMonthly: "",
  searchByQuarterly: "",
  selectYear: "",
  searchYear: "",
};
const getFormattedEndDate = (startDate:any) => {
  return dayjs(startDate, "YYYY-MM-DD").add(1, "week").format("YYYY-MM-DD");
};
const RevenueSummaryBySignInName = ({ sendDataToParent, getReportData }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessageSignIn, setErrorMessageSignIn] =
    useState<ErrorMessageTypesBySignIn>({ ...formFieldsSignIn });
  const [formDataSignIn, setFormDataSignIn] = useState({
    ...formFieldsSignIn,
    searchEndDate: getFormattedEndDate(formFieldsSignIn.searchByWeekly),
  });

  const [isFieldName, setIsFieldName] = useState("");
  
  const [selectQuarter,setSelectQuarter] = useState<any>("")

  const validationSchemaSignIn = object().shape({
    signInName: string().required("SignIn-Name is required"),
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Quarterly = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"];

  const generateArrayOfYears = () => {
    let currentYear = new Date().getFullYear();
    var lastTenYears = currentYear - 10;
    var years = [];

    for (var i = currentYear; i >= lastTenYears; i--) {
      years.push(i);
    }
    return years;
  };

        const handleSearchByDateChange = (field: any, value: any) => {
          let errors: ErrorMessageTypesBySignIn = { ...formFieldsSignIn };
          if (field === "searchByWeekly") {
              let formattedDate = dayjs(value, "YYYY-MM-DD");
              const endDate = getFormattedEndDate(formattedDate);
              setFormDataSignIn({
                ...formDataSignIn,
                [field]: formattedDate.isValid()
                  ? formattedDate.format("YYYY-MM-DD")
                  : "",
                  searchEndDate: endDate,
              });
            } else {
              setFormDataSignIn({
                  ...formDataSignIn,
                  [field]: value,
              });
          }
        errors.formError = "";
       setErrorMessageSignIn(errors);
          setIsFieldName(field);
          if(field === "searchByQuarterly"){
            switch(value){
              case 0 :
                setSelectQuarter('Jan-Mar');
                break;
              case 3 :
                setSelectQuarter('Apr-Jun');
                break;
              case 6 :
                setSelectQuarter('Jul-Sep');
                break;
              case 9 :
                setSelectQuarter('Oct-Dec');
                break;
              default:
                break;  
            }
          }
      };

  const handleClear = () => {
    setFormDataSignIn({...formDataSignIn,searchByWeekly:"",searchEndDate:"",signInName:"",
      searchByMonthly:"",searchByQuarterly:"",selectYear:"",searchYear:""});   
      setErrorMessageSignIn({...errorMessageSignIn,formError:"",selectYear:"",searchYear:"",signInName:""})
  };

  const getPoojaBookingSummarySignInReports = () => {
    const valueSelected: any = Object.entries(formDataSignIn).reduce(
      (a, [k, v]) => (v === "" ? a : (((a as any)[k] = v), a)),
      {}
    );
  
    const errors: ErrorMessageTypesBySignIn = {
      ...formFieldsSignIn,
    };
    let reqBody: any = {};
    let selectYear: number;
    let selectMonth: any;
    let startDate: any;
    let endDate: any;  
    reqBody.pagination = true;
    reqBody.pageNumber = 1;
    reqBody.searchUserName = valueSelected["signInName"] ? valueSelected["signInName"].toUpperCase() : '';
    reqBody.searchStartDate = formDataSignIn.searchByWeekly || '';
    reqBody.searchEndDate = formDataSignIn.searchEndDate || ''; 
    if (valueSelected["searchByWeekly"]) {
      reqBody.searchStartDate = formDataSignIn.searchByWeekly;
      reqBody.searchEndDate = formDataSignIn.searchEndDate; 
      startDate = dayjs(formDataSignIn.searchByWeekly).format('MM/DD/YYYY');
      endDate = dayjs(formDataSignIn.searchEndDate).format('MM/DD/YYYY');
    } else if (valueSelected["searchByMonthly"] || valueSelected["selectYear"]) {
      const selectedMonth = valueSelected["searchByMonthly"];
      const selectedYear = valueSelected["selectYear"];
  
      let monthStartDate = dayjs(new Date(selectedYear, selectedMonth, 1)).format("YYYY-MM-DD");
      let monthEndDate = dayjs(new Date(selectedYear, selectedMonth + 1, 0)).format("YYYY-MM-DD");
  
      reqBody.searchStartDate = monthStartDate;
      reqBody.searchEndDate = monthEndDate;
      console.log('Month', months[selectedMonth]);
  
      selectYear = selectedYear;
      selectMonth = months[selectedMonth];
      if(valueSelected["searchByMonthly"] && !valueSelected["selectYear"]){
        errors.selectYear = "Please select the Year from dropdown";
        setErrorMessageSignIn(errors);
        return;
      }
    } else if (valueSelected["searchByQuarterly"] || valueSelected["searchYear"]) {
      const selectedQuarter = valueSelected["searchByQuarterly"];
      const selectedYear = valueSelected["searchYear"];
      let quarterStartDate = dayjs(new Date(selectedYear, selectedQuarter )).format("YYYY-MM-DD");
      let quarterEndDate = dayjs(new Date(selectedYear, selectedQuarter+3, 0)).format("YYYY-MM-DD");
  
      reqBody.searchStartDate = quarterStartDate;
      reqBody.searchEndDate = quarterEndDate;  
      selectYear = selectedYear;
      if(valueSelected["searchByQuarterly"] && !valueSelected["searchYear"]){
        errors.searchYear = "Please select the Year from dropdown";
        setErrorMessageSignIn(errors);
        return;
      }
    }
    reqBody.searchStartDate = reqBody.searchStartDate || formDataSignIn.searchByWeekly;
    reqBody.searchEndDate = reqBody.searchEndDate || formDataSignIn.searchEndDate;
  
    if (!reqBody.searchStartDate || !reqBody.searchEndDate) {
      // If all the fields are empty, set an error message
      setErrorMessageSignIn({
        ...errorMessageSignIn,
        formError: "At least one of Weekly, Monthly, or Quarterly date must be filled",
      });
      setLoading(false);
      return;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:"/report-dashboard/reports/REVENUE_SUMMARY_REPORT_BY_SIGN_IN_NAME/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, {reqBody,
          totalDonatedAmount:res.data.totalDonatedAmount,
          totalElements:res.data.totalElements,
          pageSize:res.data.pagesize,
          devoteename:res.data.devoteename,
          dateObj:{selectYear,
          selectMonth,
          selectQuarter,
          startDate,
          endDate}});
        const response = res.data.data.map((value: any) => {
          return {
            "Date": value.dateofpayment,
            "Name (Sign-in)": value.username,
            "Pooja Booking": value.poojabookingamount ? formatAmount(value.poojabookingamount) : '' ,
            "Donation": value.donationamount ? formatAmount(value.donationamount) : '',
            "Hall Rental": value.hallrentalamount ? formatAmount(value.hallrentalamount) : '',
            "Prasadam": value.prasadamamount ? formatAmount(value.prasadamamount) : '',
            "Calendar": value.calendaramount ? formatAmount(value.calendaramount) : '',
            // "Others": value.othersamount ? formatAmount(value.othersamount) : '',
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.data?.errorCode === "RESOURCE_NOT_FOUND") {
          setErrorMessageSignIn({
              ...errorMessageSignIn,
              signInName: "Invalid Username"
          });
      }
      });
  };
  const handlSubmitSignIn = async () => {
    const errors: ErrorMessageTypesBySignIn = {
      ...formFieldsSignIn,
    };
    try {
      await validationSchemaSignIn.validate(formDataSignIn, {
        abortEarly: false,
      });
      
    const { searchByWeekly, searchByMonthly, searchByQuarterly} = formDataSignIn;
    if (!searchByWeekly && (searchByMonthly === "" || searchByMonthly === undefined) && (searchByQuarterly === "" || searchByQuarterly === undefined)) {
      errors.formError = "At least one of Weekly, Monthly, or Quarterly date must be filled";
      setErrorMessageSignIn(errors);
      return;
    }
      // If validation passes, you can submit the form
      setErrorMessageSignIn(errors);
      getPoojaBookingSummarySignInReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesBySignIn] = e.message;
          }
        });
      }
      setErrorMessageSignIn(errors);
    }
  };
  const DobDatePickerWeekly = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataSignIn.searchByWeekly
                    ? dayjs(formDataSignIn.searchByWeekly, "YYYY-MM-DD")
                    : ""
                }
                onChange={(value) => {
                  handleSearchByDateChange("searchByWeekly", value);
                }}
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const SearchByMonthlySignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchByMonthly}
            onChange={(e) => {
              handleSearchByDateChange("searchByMonthly", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {months.map((month: any, index: any) => (
              <CustomMenuItem value={index} key={index}>
                {month}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SelectYearSignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.selectYear}
            onChange={(e) => {
              handleSearchByDateChange("selectYear", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SearchByQuarterlySignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchByQuarterly}
            onChange={(e) => {
              handleSearchByDateChange("searchByQuarterly", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {Quarterly.map((quarter: any, index: any) => (
              <CustomMenuItem value={index * 3} key={index}>
                {quarter}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };
  const SearchYearSignInDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataSignIn.searchYear}
            onChange={(e) => {
              handleSearchByDateChange("searchYear", e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
      </>
    );
  };

     // Search Devotee setters and handlers
     const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

     const handleOpenSearchDevoteeDialog = () => {
       setOpenSearchDevotee(true);
     }
 
     const handleClose = () => {
       setOpenSearchDevotee(false);
     }
 
     const hanldeSelectUser = (username: string) => {
      handleSearchByDateChange(
         "signInName",
         username?.toUpperCase()
       );
       handleClose();
     } 
  return (
    <div>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Sign-In Name ", true)}
          <CustomTextFeildforFamily
            fullWidth
            required
            value={formDataSignIn.signInName}
            onChange={(e) => {
              const inputValue = e.target.value;
              setErrorMessageSignIn({ ...errorMessageSignIn, signInName: "" });
              handleSearchByDateChange("signInName", inputValue);
            }}
            onBlur={() => {
              const inputUserName = formDataSignIn.signInName.toUpperCase();
              handleSearchByDateChange('signInName', inputUserName);
            }}
            sx={{
              background:"#fff !important",
              "& .MuiOutlinedInput-root": {
                pr: "7px"
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonSearch sx={{ml: "10px", cursor: "pointer", color: "#F05802"}} onClick={handleOpenSearchDevoteeDialog}/>
                </InputAdornment>
              ),
            }}

            className={
              errorMessageSignIn.signInName
                ? styles.errorTextField
                : styles.dateFeild
            }
          />
          {errorMessageSignIn.signInName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.signInName}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Weekly", false)}
          {DobDatePickerWeekly()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Monthly", false)}
          {SearchByMonthlySignInDropdown()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Select By Year", false)}
          {SelectYearSignInDropdown()}
          {errorMessageSignIn.selectYear ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.selectYear}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Quarterly", false)}
          {SearchByQuarterlySignInDropdown()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search By Year", false)}
          {SearchYearSignInDropdown()}
          {errorMessageSignIn.searchYear ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.searchYear}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>   
      {errorMessageSignIn.formError ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.formError}
            </Typography>
          ) : (
            ""
          )}
      <Grid sx={{ marginTop: "20px", display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitSignIn}
          disabled={loading}
          id="submit"
        >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        {/* <CommonOutlinedButton onClick={handleReset}>Reset</CommonOutlinedButton> */}
        <CommonOutlinedButton onClick={handleClear}>Clear</CommonOutlinedButton>
        {openSearchDevotee && <ReportsSearchDevotee open={openSearchDevotee} handleClose={handleClose} hanldeSelectUser={hanldeSelectUser}/>}
      </Grid>
    </div>
  );
};
export default RevenueSummaryBySignInName;
